import ticketImg from '../../icons/ticket/ticket.png';
import flashImg from '../button/flash.png';
import restartIconImg from './restart_icon.png';
import restartTextImg from './restart_text.png';
import './RestartButton.css';

type RestartButtonProps = {
  onClick?: () => void;
  /** Ticket cost shown in the sub-header. */
  cost?: number;
  disabled?: boolean;
};

/** From Figma button_try_again (138:8913). */
export function RestartButton({
  onClick,
  cost = 1,
  disabled = false,
}: RestartButtonProps) {
  return (
    <button
      type="button"
      className="restart-button"
      aria-label={`Попробовать снова. Потратить ${cost}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="restart-button__sub" aria-hidden />
      <div className="restart-button__face" aria-hidden>
        <img
          className="restart-button__flash"
          src={flashImg}
          alt=""
          draggable={false}
        />
        <img
          className="restart-button__icon"
          src={restartIconImg}
          alt=""
          draggable={false}
        />
        <img
          className="restart-button__text"
          src={restartTextImg}
          alt=""
          draggable={false}
        />
      </div>
      <span className="restart-button__cost" aria-hidden>
        Потратить {cost}
      </span>
      <img
        className="restart-button__ticket"
        src={ticketImg}
        alt=""
        draggable={false}
        aria-hidden
      />
    </button>
  );
}
